import { render } from "./Changelog.vue?vue&type=template&id=c9c32a8a"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"
script.render = render

export default script